<template>
  <div class="layout-wrapper">
    <component :is="layout" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import AppLayout from "@/components/layouts/AppLayout";
import AuthLayout from "@/components/layouts/AuthLayout";

/**
 * Main vue root file of the application
 */
export default {
  /**
  |--------------------------------------------------
  | Components
  |--------------------------------------------------
  */
  components: {
    AppLayout,
    AuthLayout,
  },
  /**
  |--------------------------------------------------
  | Computed properties
  |--------------------------------------------------
  */
  computed: {
    /**
     * Fetches current route's layout
     */
    layout() {
      const { meta } = this.$route;
      if (!meta?.layout) return "";

      const { auth, app } = this.$appConfig.layouts;
      return `${this.$keycloak.authenticated ? meta.layout ?? app : auth}`;
    },
  },
  /**
  |--------------------------------------------------
  | Methods
  |--------------------------------------------------
  */
  methods: {
    ...mapActions({
      setKeycloakCurrentUserDetails: "auth/setKeycloakCurrentUserDetails",
    }),
  },
  async created() {
    try {
      if (this.$keycloak && this.$keycloak.authenticated) {
        const profile = await this.$keycloak.loadUserProfile();
        profile.phoneNumber = profile?.attributes?.phoneNumber?.[0]
        profile.companyName = profile?.attributes?.companyName?.[0]
        profile.token = this.$keycloak.token
        await this.setKeycloakCurrentUserDetails(profile)
      }
    } finally {
      document.getElementById("splash").style.display = "none";
    }
  },
};
</script>
